import { render } from "./InputFieldPrice.vue.ts?vue&type=template&id=2970f374&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InputFieldPrice.vue?vue&type=template&id=2970f374&scoped=true&ts=true"
import script from "./InputFieldPrice.vue.ts?vue&type=script&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InputFieldPrice.vue?vue&type=script&lang=ts"
export * from "./InputFieldPrice.vue.ts?vue&type=script&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InputFieldPrice.vue?vue&type=script&lang=ts"

import "./InputFieldPrice.vue.css?vue&type=style&index=0&id=2970f374&scoped=true&lang=css!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InputFieldPrice.vue?vue&type=style&index=0&id=2970f374&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2970f374"],['__file',"src/apps/merchant3/shared-components/input-fields/InputFieldPrice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2970f374"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2970f374', __exports__)) {
    api.reload('2970f374', __exports__)
  }
  
  module.hot.accept("./InputFieldPrice.vue.ts?vue&type=template&id=2970f374&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InputFieldPrice.vue?vue&type=template&id=2970f374&scoped=true&ts=true", () => {
    api.rerender('2970f374', render)
  })

}


export default __exports__